(function(angular, module) {var IssueReportController, ProgramIssues, StudentIssues, issueReportStates,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

ProgramIssues = [
  {
    name: 'program_model',
    label: 'Program Model'
  }, {
    name: 'annual_survey',
    label: 'Annual Survey'
  }, {
    name: 'amc_grant_report',
    label: 'AmC Grant Report'
  }
];

StudentIssues = [
  {
    name: 'demographics',
    label: 'Profile'
  }, {
    name: 'followup',
    label: 'Followup'
  }, {
    name: 'enrollment',
    label: 'Enrollment'
  }, {
    name: 'education',
    label: 'Education'
  }, {
    name: 'certificate',
    label: 'Certificates'
  }, {
    name: 'amc',
    label: 'AmC Slots'
  }, {
    name: 'placement',
    label: 'Placements'
  }
];

issueReportStates = function($stateProvider, TagUrl) {
  'ngInject';
  var programUrl, url;
  url = new TagUrl().addTagTypes(['program', 'location']).setTagDefault('affiliation', 'all').addExtraParam('page', {
    type: 'int',
    value: 1,
    squash: true
  }).addExtraParam('sort', 'name');
  programUrl = new TagUrl().addTagTypes(['participant']).setTagDefault('issues', 'yes').addExtraParam('page', {
    type: 'int',
    value: 1,
    squash: true
  }).addExtraParam('sort', 'name');
  $stateProvider.state('reports.issues', {
    url: url.buildUrl('/issues'),
    params: url.params,
    data: {
      tagUrl: url
    },
    templateUrl: 'reports/issueReport',
    controller: 'IssueReportController',
    controllerAs: '$ctrl',
    reloadOnSearch: false,
    resolve: {
      program: function() {
        return null;
      },
      link: function() {
        return 'program.reports.issues';
      },
      url: function(ApiUrl) {
        return ApiUrl('reports', 'issues');
      },
      columns: function() {
        return ProgramIssues.concat(StudentIssues);
      }
    }
  });
  return $stateProvider.state('program.reports.issues', {
    url: programUrl.buildUrl('/issues'),
    params: programUrl.params,
    data: {
      tagUrl: programUrl
    },
    reloadOnSearch: false,
    templateUrl: 'reports/issueReport',
    controller: 'IssueReportController',
    controllerAs: '$ctrl',
    resolve: {
      url: function(ApiUrl, program) {
        return ApiUrl('reports', 'issues', program.id);
      },
      link: function() {
        return 'student.overview';
      },
      columns: function() {
        return StudentIssues;
      }
    }
  });
};

IssueReportController = (function() {

  /* @ngInject */
  function IssueReportController($http, $scope, $timeout, $stateParams, $state, url, columns, link, program) {
    this.onPageChange = bind(this.onPageChange, this);
    this.onTagsChange = bind(this.onTagsChange, this);
    this.loadData = bind(this.loadData, this);
    this.http = $http;
    this.timeout = $timeout;
    this.state = $state;
    this.loading = true;
    this.program = program;
    this.url = url;
    this.link = link;
    this.columns = columns;
    this.sort = $stateParams.sort || 'name';
    this.page = $stateParams.page || 1;
    this.noun = this.program ? "Student" : 'Program';
    $scope.$watch('$ctrl.pager.page', this.onPageChange);
  }

  IssueReportController.prototype.triggerReload = function() {
    this.timeout.cancel(this.timeoutPromise);
    return this.timeoutPromise = this.timeout(this.loadData, 100);
  };

  IssueReportController.prototype.loadData = function() {
    var params;
    this.loading = true;
    params = angular.extend({}, this.tags, {
      sort: this.sort,
      page: this.page
    });
    this.state.go('.', params, {
      location: 'replace'
    });
    return this.http.get(this.url, {
      params: params
    }).then((function(_this) {
      return function(result) {
        _this.loading = false;
        _this.data = result.data.items;
        _this.pager = result.data.pager;
        return _this.totals = result.data.totals;
      };
    })(this));
  };

  IssueReportController.prototype.onTagsChange = function(tags) {
    if (!this.tags) {
      this.tags = tags;
      this.triggerReload();
      return;
    }
    if (!angular.equals(tags, this.tags)) {
      this.tags = tags;
      this.onPageChange(1);
      return this.triggerReload();
    }
  };

  IssueReportController.prototype.onSortChange = function() {
    this.page = 1;
    return this.triggerReload();
  };

  IssueReportController.prototype.onPageChange = function(page) {
    if (!page || page === this.page) {
      return;
    }
    this.page = page;
    return this.triggerReload();
  };

  return IssueReportController;

})();

module.config(issueReportStates);

module.controller('IssueReportController', IssueReportController);
})(angular, angular.module("dybReports"));